const localeTexts = {
  configFields: {
    all_field_instruction:
      "The 'All Fields' option allows you to add a limited number of assets based on the asset's JSON data.",
    custom_field_instruction:
      "The 'Custom Fields' option allows you to define and select the JSON data you want to save in the entry.",
    notetext:
      "Note: Switching between 'All' and 'Custom' Fields only affects the newly added assets, whereas the old assets use the previous configuration.",
    baseUrl: {
      label: "Form.io Base URL",
      help: "Get the project Base URL from your Form.io account",
      placeholder: "Enter the Form.io Base URL",
      instruction: "",
    },
    apiKey: {
      label: "Form.io API Key",
      help: "Get the project API Key from your Form.io account",
      placeholder: "Enter the Form.io Api Key",
      instruction: "",
    },
    errors: {
      emptyFields: "Please check for the blank fields",
      emptyBaseUrl: "Base URL cannot be empty. Please enter a valid Base URL",
      emptyApiKey: "API Key cannot be empty. Please enter a valid API Key",
      invalidCredentials:
        "The credentials you entered for the Form.io app are invalid. Please update the configuration details and try again.",
      invalidCreds: "Please enter valid credentials",
    },
    saveInEntry: {
      label: "Choose the Form.io Keys to Save in Entry",
      appName: "Form.io",
      help: "You can select how you want to save the data you get from form.io",
      allFields: "All Fields",
      customFields: "Custom Fields",
      instruction:
        "You can select the structure of the data you want to save in the entry, if you select Custom Fields. If you select All Fields, the data will be saved with all the keys present in the object",
      allFieldsInstruction:
        "The 'All Fields' option allows you to add all keys from the response data structure. If the form exceeds the maximum size limit, the entry cannot be saved. (Refer ",
      customFieldsInstruction:
        "The 'Custom Field' option allows you to define and select the data structure of the form (keys) you want to save in the entry. (Refer ",
      link: "Custom Fields Limitations",
      url: "https://www.contentstack.com/docs/developers/create-custom-fields/limitations-of-custom-fields/",
      contentstackSupportText:
        " for more details). To increase this limit, please contact ",
      wholeJson: "All Fields",
      supportLink: "support.",
      supportUrl: "support@contentstack.com",
      NoteText:
        "Note: Switching options with existing data in entry may cause data loss. Proceed with caution.",
    },
    keysField: {
      label: "Form.io Keys",
      help: "Select the keys you want to save",
      placeholder: "Select keys",
    },
    customWholeJson: {
      modal: {
        header: "Add Form.io Key Path",
        label: "Form.io Key Path",
        placeholder: "Enter Key Path",
        instructionS:
          'Use the dot format to enter nested objects, for eg: "file.url".',
        instructionE:
          "Label already created/added in the dropdown will not be created.",
        note: "Note: ",
        btn: {
          cancel: "Cancel",
          create: "Create",
          apply: "Create and Apply",
        },
        addOption: "New Key Field",
        successToast: {
          type: "success",
          text: "Successfully added key path to options",
        },
      },
      notification: {
        error: `The option "$var" already exists`,
        limitError: "Error: Limit of 150 options exceeded",
      },
    },
  },
  customField: {
    select: {
      label: "Choose a Form from the list.",
      placeholder: "Select a Form",
      noMoreForm: "There are no forms available",
    },
    button: "Preview",
  },
  Decryption_Keys: {
    keySize: "256",
    iterations: "100",
  },
  Warnings: {
    invalidCredentials:
      "The credentials you entered for the Form.io app are either invalid or missing. Please update the configuration details and try again.",
    somethingWentWrong:
      "Something went wrong while fetching the data, please try again.",
    cookiesBlocked:
      "Third-party cookies are blocked. To use the Form.io app, please disable this setting in your browser.",
    projectEmpty:
      "There are no forms created in the existing project in Form.io. Add some forms  to your project in Form.io and please try again.",
  },
  errors: {
    searchByName: "Error in getting specified Form",
  },
  Icons: {
    delete: "Delete",
    plus: "Plus",
    checkedWhite: "CheckedWhite",
    checkedPurple: "CheckedPurple",
    warning: "Warning",
    document: "Document",
    mp3: "MP3",
    mp4: "MP4",
    zip: "ZIP",
    doc2: "DOC2",
    json: "JSON",
    ppt: "PPT",
    xls: "XLS",
    pdf2: "PDF2",
    list: "List",
    thumbnail: "Thumbnail",
    removeFilled: "RemoveFilled",
    newTab: "NewTab",
    view: "View",
    moveIcon: "MoveIcon",
    addPlusBold: "AddPlusBold",
    dotsThreeLargeVertical: "DotsThreeLargeVertical",
    checkCircleDark: "CheckCircleDark",
    v2Plus: "v2-Plus",
  },
};

export default localeTexts;
